import React, { useState } from 'react';
import { SurveyProvider } from '../../../assets/js/SurveyContext';
import UploadModal from './UploadModal';
import CreateSurveyStep1 from './CreateSurvey_1';

const ProcessSurvey = ({ onBack }) => {
  const [isSurveyCreated, setIsSurveyCreated] = useState(false);

  return (
    <SurveyProvider>
      {isSurveyCreated ? (
        <CreateSurveyStep1 onBack={() => setIsSurveyCreated(false)} />
      ) : (
        <UploadModal onSurveyCreate={() => setIsSurveyCreated(true)} onBack={onBack} />
      )}
    </SurveyProvider>
  );
};

export default ProcessSurvey;
